const CHILDCARE_JOB_CARE_TYPES = ['BABYSITTER', 'NANNY'];

// eslint-disable-next-line import/prefer-default-export
export const allowedJobCareTypesForSearchCareType = (searchCareType: string): string[] => {
  const normalizedCareType = searchCareType.toLowerCase();
  if (['babysitter', 'nanny', 'childcare', 'both'].includes(normalizedCareType)) {
    return [...CHILDCARE_JOB_CARE_TYPES];
  }
  return [];
};
